import { useState, useEffect } from 'react';
import { useDataProvider } from 'react-admin';
import { getUserId } from '../providers/cognito';
import type { User } from '../types';

export const useCourseIds = (): string[] | undefined => {
  const dataProvider = useDataProvider();
  const [data, setData] = useState<string[] | undefined>();

  useEffect(() => {
    const userId = getUserId();

    if (!userId) return setData([]);

    dataProvider
      .getOne<User>('users', { id: userId })
      .then(({ data }) =>
        setData(data?.type === 'admin' ? undefined : data?.course_ids),
      )
      .catch(() => setData([]));
  }, [dataProvider]);

  return data;
};

export const useAssessmentIds = (): string[] | undefined => {
  const dataProvider = useDataProvider();
  const [data, setData] = useState<string[] | undefined>();
  const [assessments, setAssessments] = useState<string[] | undefined>();

  useEffect(() => {
    const userId = getUserId();

    if (!userId) return setData([]);

    dataProvider
      .getOne<User>('users', { id: userId })
      .then(({ data }) =>
        setData(data?.type === 'admin' ? undefined : data?.course_ids),
      )
      .catch(() => setData([]));
  }, [dataProvider]);

  useEffect(() => {
    if (!data) return;
    dataProvider
      .getList('assessments', {
        filter: { course_id: data },
        sort: { field: 'id', order: 'ASC' },
        pagination: { page: 1, perPage: 1000 },
      })
      .then(({ data }) =>
        setAssessments(data.map((a: any) => a.sk.split('#')[1])),
      )
      .catch(() => setAssessments([]));
  }, [data, dataProvider]);

  return assessments;
};
